import { IconSvgElement } from "@hugeicons/react";

export const DogIcon: IconSvgElement = [
  [
    "path",
    {
      d: "M10 5.172C10 3.782 8.422 2.679 6.5 3C3.676 3.47 2.386 8.606 2.5 10C2.58 10.703 4.224 11.722 6.156 10.999C7.416 10.528 8.116 9.55 8.5 8.5M14.266 5.172C14.266 3.782 15.864 2.679 17.766 3C20.59 3.47 21.88 8.606 21.766 10C21.686 10.703 20.042 11.722 18.11 10.999C16.85 10.528 16.256 9.55 15.872 8.5M8 14V14.5M16 14V14.5M11.25 16.25H12.75L12 16.999L11.25 16.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "0"
    }
  ],
  [
    "path",
    {
      d: "M4.421 11.246C4.141 12.327 4 13.439 4.001 14.555C4.001 18.727 7.583 20.999 12.001 20.999C16.419 20.999 20.001 18.727 20.001 14.555C20.001 13.494 19.839 12.354 19.508 11.246M10.265 5.164C10.837 5.052 11.418 4.997 12.001 4.999C12.781 4.999 13.501 5.107 14.162 5.305",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      key: "1"
    }
  ]
];
